<template>
  <v-card>
    <v-tabs v-model="tab">
      <v-tab>Negociações
        <px-ajuda-icon :link="linkAjuda" small btn-class=""/>
      </v-tab>
      <v-tab>Histórico de alterações</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <v-card
          flat
        >
          <v-card-text>
            <px-cotacao-frete-negociacao :solicitacao="solicitacao"/>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card
          flat
        >
          <v-card-text>
            <px-cotacao-frete-historico :solicitacao="solicitacao"/>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-card>

</template>

<script>
import { negociacao } from '@/api/ajuda-mapper';
import CotacaoFreteNegociacao from './negociacao/CotacaoFreteNegociacao.vue';
import CotacaoFreteHistorico from './CotacaoFreteHistorico.vue';

export default {
  props: {
    solicitacao: Object,
  },
  data() {
    return {
      tab: null,
      linkAjuda: negociacao,
    };
  },
  components: {
    pxCotacaoFreteNegociacao: CotacaoFreteNegociacao,
    pxCotacaoFreteHistorico: CotacaoFreteHistorico,
  },
};
</script>
